import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import {
  useWalletAssetBalance,
  useWalletAssetBalanceUsd,
} from '@root/entities/wallet/hooks'
import { AmountFormatted } from '@root/shared/core/format'

import type { PairModel } from '../../atoms'
import type { WalletModel } from '@root/entities/wallet/atoms'

type PairListItemBalanceProps = {
  pair: PairModel
  wallet: WalletModel | undefined
  variant?: 'inline' | 'vertical'
}

export const PairListItemBalance: React.FC<PairListItemBalanceProps> = ({
  pair,
  variant = 'vertical',
  wallet,
}) => {
  const quoteBalance = useWalletAssetBalance({
    wallet,
    currency: pair.quote,
  })
  const quoteBalanceUsd = useWalletAssetBalanceUsd({
    wallet,
    currency: pair.quote,
  })

  return (
    <Root $inline={variant === 'inline'}>
      <Balance $inline={variant === 'inline'}>
        <AmountFormatted
          amount={quoteBalance}
          currency={pair.quote.ticker}
          roundingMode="trunc"
        />
      </Balance>
      <BalanceAlternate $inline={variant === 'inline'}>
        <AmountFormatted
          amount={quoteBalanceUsd}
          currency="$"
          roundingMode="trunc"
        />
      </BalanceAlternate>
    </Root>
  )
}

const Root = styled.div<{ $inline: boolean }>`
  display: grid;
  ${({ $inline }) => {
    if ($inline) {
      return css`
        justify-content: start;
        grid-template-columns: auto auto;
        align-items: center;
        gap: 2px;
      `
    }
  }}
`

const Balance = styled(Typography).attrs<{ $inline: boolean }>(
  ({ $inline }) => ({
    variant: $inline ? 'body4-medium' : 'description-semi-bold',
    component: 'div',
  }),
)<{ $inline: boolean }>`
  color: var(--text-11);
  white-space: nowrap;
`

const BalanceAlternate = styled(Typography).attrs<{ $inline: boolean }>(
  ({ $inline }) => ({
    variant: $inline ? 'body4-medium' : 'description-medium',
    component: 'div',
  }),
)<{ $inline: boolean }>`
  color: var(--text-8);
  white-space: nowrap;

  ${({ $inline }) =>
    !$inline &&
    css`
      font-size: 8px;
      line-height: 8px;
    `}
`
